"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getPlatformFeeRate = exports.getCurrenciesByPurpose = exports.getRegularCurrencies = exports.getCurrencyConfig = exports.getRegularCurrenciesWithPurpose = exports.SUPPORTED_CURRENCIES = void 0;
const app_1 = require("../../../app");
const enums_1 = require("../enums");
exports.SUPPORTED_CURRENCIES = [enums_1.SystemCurrency.USDT, enums_1.SystemCurrency.OKLP];
const getRegularCurrenciesWithPurpose = (currencyType) => {
    switch (currencyType) {
        case app_1.CurrencyType.OKLP:
            return [{ currency: enums_1.SystemCurrency.OKLP, purposeType: enums_1.PurposeType.PrizePool }];
        case app_1.CurrencyType.USDT_OKLP:
            return [
                { currency: enums_1.SystemCurrency.USDT, purposeType: enums_1.PurposeType.PrizePool },
                { currency: enums_1.SystemCurrency.OKLP, purposeType: enums_1.PurposeType.PlatformFee },
            ];
        case app_1.CurrencyType.USDT_USDT:
            return [
                { currency: enums_1.SystemCurrency.USDT, purposeType: enums_1.PurposeType.PrizePool },
                { currency: enums_1.SystemCurrency.USDT, purposeType: enums_1.PurposeType.PlatformFee },
            ];
        default:
            return [];
    }
};
exports.getRegularCurrenciesWithPurpose = getRegularCurrenciesWithPurpose;
const getCurrencyConfig = (currencyType) => {
    switch (currencyType) {
        case app_1.CurrencyType.OKLP:
            return { main: enums_1.SystemCurrency.OKLP };
        case app_1.CurrencyType.USDT_OKLP:
            return { main: enums_1.SystemCurrency.USDT, platformFee: enums_1.SystemCurrency.OKLP };
        case app_1.CurrencyType.USDT_USDT:
            return { main: enums_1.SystemCurrency.USDT, platformFee: enums_1.SystemCurrency.USDT };
        default:
            return null;
    }
};
exports.getCurrencyConfig = getCurrencyConfig;
const getRegularCurrencies = (currencyType) => {
    switch (currencyType) {
        case app_1.CurrencyType.OKLP:
            return [enums_1.SystemCurrency.OKLP];
        case app_1.CurrencyType.USDT_OKLP:
            return [enums_1.SystemCurrency.USDT, enums_1.SystemCurrency.OKLP];
        case app_1.CurrencyType.USDT_USDT:
            return [enums_1.SystemCurrency.USDT];
        default:
            return [];
    }
};
exports.getRegularCurrencies = getRegularCurrencies;
const getCurrenciesByPurpose = (purpose) => {
    return purpose.map(({ currency }) => currency);
};
exports.getCurrenciesByPurpose = getCurrenciesByPurpose;
const getPlatformFeeRate = (currencyType) => {
    switch (currencyType) {
        case app_1.CurrencyType.USDT_OKLP:
            return enums_1.ExchangeRateName.OKLP_USDT;
        case app_1.CurrencyType.USDT_USDT:
            return enums_1.ExchangeRateName.USDT_USDT;
        case app_1.CurrencyType.OKLP:
        default:
            return null;
    }
};
exports.getPlatformFeeRate = getPlatformFeeRate;
//# sourceMappingURL=currency-utils.js.map